(() => {
  const evaUpsellSelector =
    'product-info-upsell[data-handle="jade-hartjesarmband"]';
  const fastShippingProductSelector = 'product-info[data-fast-shipping="true"]';
  const inventorySelector = '[id^="Inventory-"][class*="product__inventory"]';
  const fastShippingText = 'Voor 23:00 besteld, morgen verzonden';
  const fastShippingIcon = `
    <svg width="15" height="15" aria-hidden="true">
      <circle cx="7.5" cy="7.5" r="7.5" fill="rgb(62,214,96, 0.3)"></circle>
      <circle cx="7.5" cy="7.5" r="5" stroke="rgb(255, 255, 255)" stroke-width="1" fill="rgb(62,214,96)"></circle>
    </svg>`;

  const keepEvaSelected = (root = document) => {
    const upsells = [];

    if (root instanceof Element && root.matches(evaUpsellSelector)) {
      upsells.push(root);
    }

    if (root.querySelectorAll) {
      upsells.push(...root.querySelectorAll(evaUpsellSelector));
    }

    upsells.forEach((upsell) => {
      if (upsell.dataset.selected !== 'true') {
        upsell.dataset.selected = 'true';
      }
    });
  };

  const updateFastShippingText = (root = document) => {
    const productInfos = [];

    if (root instanceof Element && root.matches(fastShippingProductSelector)) {
      productInfos.push(root);
    }

    if (root.querySelectorAll) {
      productInfos.push(...root.querySelectorAll(fastShippingProductSelector));
    }

    productInfos.forEach((productInfo) => {
      const inventory = productInfo.querySelector(inventorySelector);

      if (!inventory || !inventory.textContent.includes('Op voorraad')) return;
      if (inventory.textContent.includes(fastShippingText)) return;

      inventory.innerHTML = `${fastShippingIcon}${fastShippingText}`;
    });
  };

  const initialize = () => {
    keepEvaSelected();
    updateFastShippingText();

    document.addEventListener(
      'click',
      (event) => {
        const toggle = event.target.closest(
          `${evaUpsellSelector} .upsell-toggle-btn`
        );

        if (!toggle) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        keepEvaSelected(toggle.closest(evaUpsellSelector));
      },
      true
    );

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes') {
          keepEvaSelected(mutation.target);
          return;
        }

        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;

          keepEvaSelected(node);

          const productInfo = node.matches(fastShippingProductSelector)
            ? node
            : node.closest(fastShippingProductSelector);

          if (productInfo) updateFastShippingText(productInfo);
        });
      });
    }).observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-selected'],
      childList: true,
      subtree: true,
    });

    document
      .querySelectorAll(fastShippingProductSelector)
      .forEach((productInfo) => {
        new MutationObserver(() => updateFastShippingText(productInfo)).observe(
          productInfo,
          { childList: true, subtree: true }
        );
      });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
